import React from 'react';
import { Box, Flex } from 'rebass';

import { alternativeSceneLink } from './alternative-scene-link';

export type ContainerProps = {
  children: React.ReactNode;
  alternativeScene?: 'sign-up' | 'login';
  onLoginLinkClicked: () => void;
  onSignUpLinkClicked: () => void;
};

export const InWellContainer = ({
  children,
  alternativeScene,
  onLoginLinkClicked,
  onSignUpLinkClicked,
}: ContainerProps) => {
  const alternativeSceneElement = alternativeSceneLink({
    alternativeScene,
    onLoginLinkClicked,
    onSignUpLinkClicked,
  });

  return (
    <Box backgroundColor="rgba(168, 151, 134, 0.1)" p="8px">
      <Flex justifyContent="center">
        {alternativeSceneElement ? (
          <Box pt={['0px', '4px']} pb={['8px', '10px']}>
            {alternativeSceneElement}{' '}
          </Box>
        ) : null}
      </Flex>

      <Box width="100%" backgroundColor="#fff" padding="12px">
        <Box maxWidth="400px" mx="auto" pt={['12px', '24px']} pb="16px">
          {children}
        </Box>
      </Box>
    </Box>
  );
};
